import { Reference, useMutation } from "@apollo/client";

import {
  ProviderCreateDocument,
  ProviderCreateMutation,
  ProviderCreateMutationVariables,
  ProviderFragmentDoc
} from "@typing/Generated";

const useCreateProvider = (journeyId: string) => {
  const [createProvider] = useMutation<ProviderCreateMutation, ProviderCreateMutationVariables>(
    ProviderCreateDocument,
    {
      update: (store, { data }) => {
        if (data?.providerCreate?.provider) {
          store.modify({
            fields: {
              providers(cachedProvidersRefs: readonly Reference[]) {
                const newProviderRef = store.writeFragment({
                  data: data.providerCreate?.provider,
                  fragment: ProviderFragmentDoc,
                  fragmentName: "Provider"
                });
                if (newProviderRef && data.providerCreate?.provider) {
                  return [...cachedProvidersRefs, newProviderRef];
                }
                return [...cachedProvidersRefs];
              }
            },
            id: store.identify({ __typename: "Journey", id: journeyId })
          });
        }
      }
    }
  );

  return createProvider;
};

export default useCreateProvider;
